<script>
import WorkerPage from "@/views/Worker/WorkerPage.vue";

export default {
    components: {WorkerPage}
}
</script>

<template>
    <worker-page intranet/>
</template>